module.exports = __webpack_public_path__ + "static/media/dental_splints_occlusal_guards.30848edf.jpg";